export default class Tab {
    constructor(main) {
        this.main = main;

        this._setTab();
    }

    _setTab() {
        const $tabs = [...document.querySelectorAll(".js-tab")];

        for (const $tab of $tabs) {
            this._eventBind($tab);
        }
    }

    _eventBind($tab) {
        const $btns = [...$tab.querySelectorAll(".js-tab_btn")];
        const $conts = [...$tab.querySelectorAll(".js-tab_box")];
        const $bar = $tab.querySelector(".js-tab_bar");

        $btns.forEach(($btn, i) => {
            $btn.addEventListener("click", () => {
                const $selectedBtn = $btns.find(($btn) => $btn.classList.contains("-select"));
                const $selectedCont = $conts.find(($cont) => $cont.classList.contains("-select"));

                $selectedBtn.classList.remove("-select");
                $selectedCont.classList.remove("-select");

                $btn.classList.add("-select");
                $conts[i].classList.add("-select");

                if ($bar) {
                    $bar.style.left = `${(100 / $btns.length) * i}%`;
                }

                this.main.acc.setHeight();
            });
        });
    }
}
